var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { commonAttrs } from '../../../utils';
import { CFDotBadgeElements } from './DotBadge.styles';
export const CFDotBadge = (_a) => {
    var { color = 'default', position, size = 'md', border = true } = _a, rest = __rest(_a, ["color", "position", "size", "border"]);
    const { Root } = CFDotBadgeElements;
    return (React.createElement(Root, Object.assign({ "$color": color, "$position": position, "$size": size, "$border": border }, commonAttrs(rest))));
};
